import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import * as XLSX from 'xlsx';
import { Modal } from 'bootstrap';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default function ListStudentDetails() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, name } = location.state || {};
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState([]); // State for unique subjects
  const [file, setFile] = useState(null); // State for selected file
  const [fileName, setFileName] = useState(''); // State for selected file name
  const [uploading, setUploading] = useState(false); // State for upload status
  const modalRef = useRef(); // Reference for the modal
  const [invalidRows, setInvalidRows] = useState([]); // State to store invalid rows data
  const [showInvalidRows, setShowInvalidRows] = useState(true);
  const [setErrorMessage, setInvalidMessage] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const ClientName = localStorage.getItem('ClientName');

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
  }, []);

  const fetchRecords = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${apiUrl}/api/students`, {
        headers: {
          Authorization: token,
        },
        params: {
          examId: id, // Include examId in the request parameters
        },
      });
      const { students } = response.data; // Destructure the response data
      setRecords(students);
      // Extract unique subjects from the students array
      const allSubjects = students.flatMap((student) =>
        student.subjectCode.flatMap((sub) => Object.keys(sub))
      );
      const uniqueSubjects = [...new Set(allSubjects)];
      setSubjects(uniqueSubjects);
      setCount(response.data.totalStudents);
      setLoading(false);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching records:', error);
      setLoading(false);
    }
  };
  // Generate dynamic columns for each subject with defined width
  const subjectColumns = subjects.map((subject) => ({
    name: subject,
    selector: (row) => {
      const subjectObj = row.subjectCode.find(
        (sub) => sub[subject] !== undefined
      );
      return subjectObj ? subjectObj[subject] : '';
    },
    cell: (row) => {
      const subjectObj = row.subjectCode.find(
        (sub) => sub[subject] !== undefined
      );
      return <div>{subjectObj ? subjectObj[subject] : ''}</div>;
    },
    width: '150px',
    center: 'true',
  }));
  // Base columns for other student details
  const baseColumns = [
    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Roll Number',
      selector: (row) => row.rollNumber,
      sortable: true,
      width: '118px',
      center: 'true',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: 'true',
    },
  ];

  // "Actions" column
  const actionColumn = {
    name: 'Actions',
    width: '115px',
    center: 'true',
    cell: (row) => (
      <div>
        <button
          onClick={() =>
            navigate('/EditStudentDetails', {
              state: { id: row.id, examId: row.examId },
            })
          }
          className="btn btn-primary btn-sm mx-1"
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Update Student Details"
        >
          <i className="bi bi-pencil-square"></i>
        </button>
        <button
          className="btn btn-outline-danger btn-sm mx-1"
          onClick={() => handleDelete(row.id)}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Delete Student"
        >
          <i className="bi bi-trash3-fill"></i>
        </button>
      </div>
    ),
  };

  // Combine base columns with dynamic subject columns and place the "Actions" column at the end
  const columns = [...baseColumns, ...subjectColumns, actionColumn];
  const handleDelete = (Id) => {
    const isConfirmed = window.confirm(
      'Are you sure you want to delete this student?'
    );
    if (!isConfirmed) {
      return;
    }
    const token = localStorage.getItem('token');

    axios
      .delete(`${apiUrl}/api/students/${Id}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.success('Student deleted successfully');
        fetchRecords();
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        toast.error(err.response.data.message);
        fetchRecords();
      });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : '');
  };
  const handleUpload = async () => {
    if (!file) {
      toast.error('No file selected');
      return;
    }
    setUploading(true);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('student', file);
    try {
      const response = await axios.post(
        `${apiUrl}/api/students/upload?examId=${id}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      toast.success('File uploaded successfully');
      fetchRecords();
      closemodel();
      // Reset invalid rows state and make sure the table will show on next upload
      if (modalRef.current) {
        const modal = Modal.getInstance(modalRef.current);
        modal.hide();
      }
      setInvalidRows([]); // Reset invalid rows after a successful upload
      setShowInvalidRows(true); // Ensure the table will be shown again on next upload
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      if (error.response && error.response.data.invalidRows) {
        // Update state with invalid rows
        setInvalidRows(error.response.data.invalidRows);
        setInvalidMessage(error.response.data.message);
        setShowInvalidRows(true); // Ensure the invalid rows table is shown after failed upload
      } else {
        toast.error(error.response?.data?.message || 'Upload failed');
      }
      fetchRecords();
      closemodel();
    } finally {
      setUploading(false);
      setFile(null);
      setFileName('');
      document.getElementById('formFile-question').value = null;
    }
  };

  const handleHideTable = () => {
    setShowInvalidRows(false);
    setInvalidRows([]); // Clear the invalid rows only when hiding the table
  };

  const closemodel = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };
  const [subjectOptions, setSubjectOptions] = useState([]); // Initialize state for subject options
  useEffect(() => {
    // Fetch subjects from the updated API
    const token = localStorage.getItem('token');
    axios
      .get(`${apiUrl}/api/subject/list/${id}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        // Map the API response to react-select options
        const subjects = res.data.subjectExam.map((subject) => ({
          value: subject.subjectCode, // Store the subjectCode as the value
          label: `${subject.subjectname} (${subject.subjectCode})`, // Display subject name and code
          name: subject.subjectname, // Store subject name
        }));
        setSubjectOptions(subjects); // Set the options for react-select
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        console.error('Failed to fetch subjects:', err);
      });
  }, [apiUrl]);

  const handleDownload = () => {
    if (!subjectOptions.length) {
      console.error('No subjects available to generate the sheet.');
      return;
    }

    // Prepare the header row dynamically
    const headers = [
      'rollNumber',
      'name',
      ...subjectOptions.map((subject) => subject.name),
    ]; // Only use the subject name in headers

    // Example student data
    const students = [
      { rollNumber: '', name: '', marks: {} }, // Replace with actual data
    ];

    // Prepare the data rows
    const data = [
      headers, // Add the header row first
      ...students.map((student) => [
        student.rollNumber,
        student.name,
        ...subjectOptions.map((subject) => {
          const mark = student.marks[subject.value] || ''; // Fetch marks or use placeholder
          return `${mark}${subject.value}`; // Include marks and subject code in the same cell
        }),
      ]),
    ];

    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    // Convert data to worksheet format
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Set custom styles to wrap text in Excel (optional)
    worksheet['!cols'] = headers.map(() => ({ wch: 20 })); // Adjust column widths for better visibility

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'SubjectsSheet');
    // Export the Excel file
    XLSX.writeFile(workbook, `${name} student.xlsx`);
  };

  const getUniqueSubjects = () => {
    const subjectSet = new Set();
    invalidRows.forEach((row) => {
      if (row.invalidSubjectCodes && Array.isArray(row.invalidSubjectCodes)) {
        row.invalidSubjectCodes.forEach((subject) => {
          const subjectName = Object.keys(subject)[0];
          subjectSet.add(subjectName);
        });
      }
    });
    return Array.from(subjectSet);
  };

  const dynamicSubjectColumns = getUniqueSubjects().map((subjectName) => ({
    name: subjectName,
    selector: (row) => {
      if (row.invalidSubjectCodes && Array.isArray(row.invalidSubjectCodes)) {
        const subjectObj = row.invalidSubjectCodes.find(
          (sub) => Object.keys(sub)[0] === subjectName
        );
        return subjectObj ? subjectObj[subjectName] : '';
      }
      return ''; // Return an empty string if invalidSubjectCodes is undefined
    },
    cell: (row) => {
      if (row.invalidSubjectCodes && Array.isArray(row.invalidSubjectCodes)) {
        const subjectObj = row.invalidSubjectCodes.find(
          (sub) => Object.keys(sub)[0] === subjectName
        );
        return (
          <div style={{ fontSize: '14px' }}>
            {subjectObj ? subjectObj[subjectName] : ''}
          </div>
        );
      }
      return <div style={{ fontSize: '14px' }}></div>; // Empty cell if invalidSubjectCodes is undefined
    },
    width: '150px',
    center: 'true',
  }));

  const exportToExcel = () => {
    const wsData = [];

    // Add headers
    wsData.push([
      'name',
      'rollNumber',
      ...getUniqueSubjects(), // Dynamic subject names
    ]);
    // Add rows
    invalidRows.forEach((row) => {
      const rowData = [
        row.name,
        row.rollNumber,
        ...getUniqueSubjects().map((subjectName) => {
          const subjectObj = row.invalidSubjectCodes.find(
            (sub) => Object.keys(sub)[0] === subjectName
          );
          return subjectObj ? subjectObj[subjectName] : '';
        }),
      ];
      wsData.push(rowData);
    });
    // Create a new workbook and add the worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, 'Invalid Rows');
    // Export the Excel file
    XLSX.writeFile(wb, 'invalid_rows.xlsx');
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set font size for the header
    doc.setFontSize(18);

    // Get the page width
    const pageWidth = doc.internal.pageSize.width;

    // Define header text
    const firstLine = `${ClientName}  ${name}`;
    const secondLine = 'Student List';

    // Function to add the header text
    const addHeader = () => {
      const firstLineWidth = doc.getTextWidth(firstLine);
      doc.text(firstLine, (pageWidth - firstLineWidth) / 2, 15);

      const secondLineWidth = doc.getTextWidth(secondLine);
      doc.text(secondLine, (pageWidth - secondLineWidth) / 2, 25);
    };

    // Add the first page header
    addHeader();

    // Get the table headers (baseColumns)
    const headers = [
      ['No', 'Roll Number', 'Name', 'Student Sign'], // Add subject columns dynamically
    ];

    // Get the rows of data
    const rows = records.map((record, index) => {
      const rowData = [
        (currentPage - 1) * rowsPerPage + index + 1,
        record.rollNumber,
        record.name,
      ];
      return rowData;
    });

    // Define a margin to avoid overlap with the header
    const tableStartY = 35;

    // Add table to PDF with dark borders
    doc.autoTable({
      head: headers,
      body: rows,
      startY: tableStartY, // Start Y position after header
      theme: 'grid',
      headStyles: {
        fillColor: 'white', // Header background color
        textColor: 'black', // Text color
        fontStyle: 'bold',
        fontSize: 15,
        lineColor: [0, 0, 0], // Border color
        lineWidth: 0.4, // Border thickness
      },
      bodyStyles: {
        lineColor: [0, 0, 0], // Border color
        lineWidth: 0.4, // Border thickness
      },
      styles: {
        fontSize: 10, // Default font size for body
        cellPadding: 1.9,
        fillColor: null, // No background color
        textColor: 'black', // Text color is black
      },
      margin: { top: 30, left: 5, right: 5, bottom: 15 },
      didDrawPage: (data) => {
        // Add the header on each new page
        addHeader();
      },
    });

    // Save the generated PDF
    doc.save('Exam_Student_List.pdf');
  };

  return (
    <AdminLayout ac6="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/StudentDasboard">Exams for Student</Link>
              </li>
              <li className="breadcrumb-item active">
                Students Details of {name} ({count})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        {showInvalidRows && invalidRows.length > 0 && (
          <div className="card">
            <div className="card-body" style={{ backgroundColor: '#f0b7b7' }}>
              <div className="mt-2 mb-2">
                <div className="d-flex justify-content-between">
                  <div className="bd-highlight ms-5"></div>
                  <div className="bd-highlight ms-4 mt-2 ps-5">
                    <strong>{setErrorMessage}</strong>
                  </div>
                  <div className="bd-highlight">
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      onClick={exportToExcel}
                    >
                      <i className="bi bi-file-earmark-excel"></i> Export to
                      Excel
                    </button>
                    <button
                      className="btn btn-secondary ms-2 btn-sm"
                      onClick={handleHideTable}
                    >
                      <i className="bi bi-x-circle"></i> Close
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                {invalidRows.every(
                  (row) =>
                    !row.invalidSubjectCodes ||
                    row.invalidSubjectCodes.length === 0
                ) ? (
                  <div className="text-center mt-4">
                    <strong>
                      {' '}
                      All records are invalid Please check the data and try
                      again
                    </strong>
                  </div>
                ) : (
                  <DataTable
                    columns={[
                      {
                        name: 'No',
                        selector: (row, index) => index + 1,
                        width: '50px',
                        center: 'true',
                      },
                      {
                        name: 'Roll Number',
                        selector: (row) => row.rollNumber || 'N/A',
                        width: '150px',
                      },
                      { name: 'Name', selector: (row) => row.name || 'N/A' },
                      ...dynamicSubjectColumns,
                    ]}
                    data={invalidRows}
                    noDataComponent="No data available"
                    className="custom-table error-table"
                  />
                )}
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="container ">
            <div className="col-lg-15">
              <div className="datatable-top">
                <div className="datatable-search d-flex">
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Search"
                    title="Search within table"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-primary mx-2"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Upload Excel File"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <i className="bi bi-file-earmark-arrow-up"></i> Upload
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary me-2 "
                    onClick={() =>
                      navigate('/AddStudentDetails', {
                        state: { id: id, name: name },
                      })
                    }
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Add New Student"
                  >
                    <i className="bi bi-plus-square"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary "
                    onClick={generatePDF}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Ganrete Studant List pdf"
                  >
                    <i class="bi bi-filetype-pdf"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records.filter((record) => {
                    const nameMatches = record.name
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase());
                    const rollNumberMatches = record.rollNumber
                      .toString() // Convert rollNumber to string
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase());
                    return nameMatches || rollNumberMatches;
                  })}
                  progressPending={loading}
                  pagination
                  className="custom-table"
                  paginationPerPage={rowsPerPage} // Set rows per page
                  paginationTotalRows={records.length} // Total number of records
                  paginationDefaultPage={currentPage} // Default starting page
                  onChangePage={(page) => setCurrentPage(page)} // Update current page
                  onChangeRowsPerPage={(newPerPage) =>
                    setRowsPerPage(newPerPage)
                  } // Update rows per page
                />
                <div className="d-flex justify-content-end mt-3"></div>
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
                <Tooltip id="my-tooltip" />
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Modal for File Upload */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-ms">
          <div className="modal-content">
            <div className="modal-header bg-secondary">
              <h5
                className="modal-title text-white p-1 rounded"
                id="exampleModalLabel"
              >
                {name}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="col text-center">
                <label className="mb-2">Upload Student Details </label>
                <div
                  className="upload-area"
                  onClick={() =>
                    document.getElementById('formFile-question').click()
                  }
                  style={{ cursor: 'pointer', width: '465px' }}
                >
                  <div className="icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                      alt="Upload"
                    />
                  </div>
                  <p className="text">Click to upload Student Details</p>
                  <input
                    className="form-control"
                    name="questionpaper"
                    type="file"
                    id="formFile-question"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    accept=".xlsx"
                  />
                  {fileName && (
                    <div className="mt-2">
                      <strong>{fileName}</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary mx-1"
                onClick={handleDownload}
              >
                Download Example
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpload}
                disabled={uploading}
              >
                {uploading ? 'Uploading...' : 'Upload'}
              </button>
              <button
                type="button"
                className="btn btn-secondary mx-1"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
